import type { ReactElement } from "react";

/**
 * "Spalten": a native disclosure with one checkbox per optional column. No menu library: the
 * list is short, and `<details>` opens and closes by keyboard without a script of its own.
 */
export function ColumnPicker<K extends string>({
  labels,
  columns,
  onChange,
}: {
  readonly labels: Readonly<Record<K, string>>;
  readonly columns: Readonly<Record<K, boolean>>;
  readonly onChange: (column: K, shown: boolean) => void;
}): ReactElement {
  return (
    <details className="relative text-sm">
      <summary className="cursor-pointer select-none border border-input px-3 py-1.5 font-medium">
        Spalten
      </summary>
      <fieldset className="absolute right-0 z-10 mt-1 grid min-w-56 gap-2 border border-border bg-background p-3 shadow-md">
        <legend className="sr-only">Sichtbare Spalten</legend>
        {(Object.keys(labels) as K[]).map((column) => (
          <label key={column} className="flex items-center gap-2">
            <input
              type="checkbox"
              className="border border-input"
              checked={columns[column]}
              onChange={(event) => {
                onChange(column, event.target.checked);
              }}
            />
            {labels[column]}
          </label>
        ))}
      </fieldset>
    </details>
  );
}
